import Box from '@mui/material/Box';
import BrandLockup from './BrandLockup';

const AuthBrandHeader = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: '24px' }}>
    <BrandLockup align="center" size="large" showTagline to="/" />
  </Box>
);

export default AuthBrandHeader;
